import React, { useState, useEffect } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { Text, List, Switch, Divider, Button, useTheme, Snackbar } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

const NotificationSettingsScreen = ({ navigation }) => {
  const theme = useTheme();
  
  // Bildirim ayarları
  const [newVisitNotification, setNewVisitNotification] = useState(true);
  const [visitEndNotification, setVisitEndNotification] = useState(true);
  const [newUserNotification, setNewUserNotification] = useState(true);
  const [emailNotifications, setEmailNotifications] = useState(false);
  const [smsNotifications, setSmsNotifications] = useState(false);
  const [nightNotifications, setNightNotifications] = useState(false);
  
  // UI state
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [hasChanges, setHasChanges] = useState(false);
  
  // İlk değerleri sakla, değişiklikleri izle
  const [initialValues, setInitialValues] = useState({
    newVisitNotification: true,
    visitEndNotification: true,
    newUserNotification: true,
    emailNotifications: false,
    smsNotifications: false,
    nightNotifications: false
  });
  
  useEffect(() => {
    // Ayarların değişip değişmediğini kontrol et
    if (
      newVisitNotification !== initialValues.newVisitNotification ||
      visitEndNotification !== initialValues.visitEndNotification ||
      newUserNotification !== initialValues.newUserNotification ||
      emailNotifications !== initialValues.emailNotifications ||
      smsNotifications !== initialValues.smsNotifications ||
      nightNotifications !== initialValues.nightNotifications
    ) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  }, [
    newVisitNotification,
    visitEndNotification,
    newUserNotification,
    emailNotifications,
    smsNotifications,
    nightNotifications
  ]);
  
  const handleSaveSettings = () => {
    // API çağrısı burada yapılacak
    
    // Mevcut değerleri yeni başlangıç değerleri olarak kaydet
    setInitialValues({
      newVisitNotification,
      visitEndNotification,
      newUserNotification,
      emailNotifications,
      smsNotifications,
      nightNotifications
    });
    
    setSnackbarMessage('Bildirim ayarları güncellendi');
    setSnackbarVisible(true);
    setHasChanges(false);
  };
  
  const handleResetSettings = () => {
    // Tüm değerleri başlangıç değerlerine sıfırla
    setNewVisitNotification(initialValues.newVisitNotification);
    setVisitEndNotification(initialValues.visitEndNotification);
    setNewUserNotification(initialValues.newUserNotification);
    setEmailNotifications(initialValues.emailNotifications);
    setSmsNotifications(initialValues.smsNotifications);
    setNightNotifications(initialValues.nightNotifications);
    
    setHasChanges(false);
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.content}>
        {/* Bilgilendirici başlık */}
        <View style={styles.headerContainer}>
          <MaterialCommunityIcons name="bell-ring" size={32} color={theme.colors.primary} />
          <Text style={styles.headerText}>Bildirim Ayarları</Text>
        </View>
        <Text style={styles.descriptionText}>
          Hangi durumlarda bildirim almak istediğinizi seçin. Bildirimler, uygulama içi bildirimler, e-posta veya SMS olarak gönderilebilir.
        </Text>
        
        {/* Bildirim Türleri */}
        <View style={styles.sectionContainer}>
          <Text style={styles.sectionTitle}>Bildirim Türleri</Text>
          
          <List.Item
            title="Yeni Ziyaret Bildirimleri"
            description="Yeni bir ziyaret başladığında bildirim al"
            left={props => <List.Icon {...props} icon="account-check" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={newVisitNotification} 
                onValueChange={setNewVisitNotification}
                color={theme.colors.primary}
              />
            }
          />
          
          <Divider />
          
          <List.Item
            title="Ziyaret Sonu Bildirimleri"
            description="Bir ziyaret sona erdiğinde bildirim al"
            left={props => <List.Icon {...props} icon="exit-run" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={visitEndNotification} 
                onValueChange={setVisitEndNotification}
                color={theme.colors.primary}
              />
            }
          />
          
          <Divider />
          
          <List.Item
            title="Yeni Kullanıcı Bildirimleri"
            description="Yeni bir kullanıcı kayıt olduğunda bildirim al"
            left={props => <List.Icon {...props} icon="account-plus" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={newUserNotification} 
                onValueChange={setNewUserNotification}
                color={theme.colors.primary}
              />
            }
          />
        </View>
        
        {/* Bildirim Kanalları */}
        <View style={styles.sectionContainer}>
          <Text style={styles.sectionTitle}>Bildirim Kanalları</Text>
          
          <List.Item
            title="E-posta Bildirimleri"
            description="Bildirimleri e-posta olarak al"
            left={props => <List.Icon {...props} icon="email" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={emailNotifications} 
                onValueChange={setEmailNotifications}
                color={theme.colors.primary}
              />
            }
          />
          
          <Divider />
          
          <List.Item
            title="SMS Bildirimleri"
            description="Bildirimleri SMS olarak al"
            left={props => <List.Icon {...props} icon="message-text" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={smsNotifications} 
                onValueChange={setSmsNotifications}
                color={theme.colors.primary}
              />
            }
          />
        </View>
        
        {/* Ek Ayarlar */}
        <View style={styles.sectionContainer}>
          <Text style={styles.sectionTitle}>Ek Ayarlar</Text>
          
          <List.Item
            title="Gece Bildirimleri"
            description="22:00 - 08:00 arasında bildirim al"
            left={props => <List.Icon {...props} icon="weather-night" color={theme.colors.primary} />}
            right={props => 
              <Switch 
                value={nightNotifications} 
                onValueChange={setNightNotifications}
                color={theme.colors.primary}
              />
            }
          />
        </View>
        
        {/* Butonlar */}
        <View style={styles.buttonContainer}>
          <Button
            mode="contained"
            onPress={handleSaveSettings}
            style={styles.saveButton}
            disabled={!hasChanges}
          >
            Kaydet
          </Button>
          
          <Button
            mode="outlined"
            onPress={handleResetSettings}
            style={styles.resetButton}
            disabled={!hasChanges}
          >
            Sıfırla
          </Button>
        </View>
      </View>
      
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        duration={3000}
      >
        {snackbarMessage}
      </Snackbar>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  content: {
    padding: 16,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  headerText: {
    fontSize: 22,
    fontWeight: 'bold',
    marginLeft: 8,
  },
  descriptionText: {
    color: '#757575',
    marginBottom: 24,
    lineHeight: 20,
  },
  sectionContainer: {
    backgroundColor: 'white',
    borderRadius: 8,
    marginBottom: 16,
    overflow: 'hidden',
    elevation: 1,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    padding: 16,
    paddingBottom: 8,
  },
  buttonContainer: {
    marginTop: 16,
    marginBottom: 32,
  },
  saveButton: {
    marginBottom: 12,
    paddingVertical: 8,
  },
  resetButton: {
    paddingVertical: 8,
  },
});

export default NotificationSettingsScreen;
